<template>
  <div class="step-profile">
    <form
      class="form"
      @invalid.capture.prevent="handleInvalid"
      @submit.prevent="handleSubmit"
      @change="handleChange"
    >
      <fieldset class="fieldset">
        <legend class="legend">
          Create an Account
        </legend>

        <Email
          v-model="form.email"
          :error="formErrors['email']"
          :label="studentPass ? 'Student Email Address' : undefined"
        />

        <Input
          id="password"
          v-model="form.password"
          label="Password"
          error-code="UserPasswordInvalid"
          autocomplete="new-password"
          minlength="6"
          :error="formErrors.password"
          passwordrules="minlength: 6;"
          :type="showPassword ? 'text' : 'password'"
          autocapitalize="off"
          autocorrect="off"
          required
        />

        <p class="form__note form__note--show-password">
          <button
            title="Show password"
            class="show-password button-link"
            aria-controls="password"
            @click.prevent="showPassword = !showPassword"
          >
            <template v-if="showPassword">
              Hide Password
            </template>
            <template v-if="!showPassword">
              Show Password
            </template>
          </button>
        </p>

        <div class="form__row">
          <div class="form__column">
            <Input
              id="first-name"
              v-model="form.firstName"
              label="First Name"
              error-code="UserFirstNameInvalid"
              autocomplete="given-name"
              :error="formErrors['first-name']"
              required
              aria-required="true"
            />
          </div>
          <div class="form__column">
            <Input
              id="last-name"
              v-model="form.lastName"
              label="Last Name"
              error-code="UserLastNameInvalid"
              autocomplete="family-name"
              :error="formErrors['last-name']"
              required
              aria-required="true"
            />
          </div>
        </div>

        <Phone
          v-if="!enableSms"
          id="phone"
          v-model="form.phone"
          label="Phone Number"
          required
          :error="formErrors.phone"
          error-code="UserPhoneNumberInvalid"
          aria-required="true"
        />

        <div
          v-if="regions.length > 1"
          class="form__column form__column--region"
        >
          <label
            class="label"
            for="region"
          >Where do you plan to use Metro Bike Share the most?</label>
          <select
            id="region"
            v-model="form.region"
            class="select select--small"
            :class="formErrors.region ? 'input--error' : ''"
            name="region"
            required
          >
            <option :value="null">
              Select
            </option>
            <option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
            >
              {{ region.title }}
            </option>
          </select>
          <p
            v-if="formErrors.region"
            class="form__error"
          >
            {{ formErrors.region }}
          </p>
        </div>
      </fieldset>
      <div class="navigation-buttons">
        <input
          type="submit"
          class="button button--submit"
          :disabled="!isFilled"
          value="Continue"
        >
        <PreviousStepButton />
      </div>
    </form>
    <hr>
    <p>
      <a href="/profile/">Have an account? Log in here</a>
    </p>
  </div>
</template>
<script>
import Email from '../components/Email.vue';
import Input from '../components/Input.vue';
import Phone from '../components/Phone.vue';
import PreviousStepButton from '../components/PreviousStepButton.vue';

export default {
  components: {
    Email,
    Input,
    Phone,
    PreviousStepButton,
  },
  data() {
    const { user } = this.$store.state;
    return {
      showPassword: false,
      form: {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
        password: user.password,
        region: user.region,
      },
      formErrors: {},
    };
  },
  computed: {
    registration() {
      return this.$store.state.registration;
    },
    passType() {
      return this.$store.getters.passType;
    },
    regions() {
      return this.$store.state.regions;
    },
    studentPass() {
      if (this.$store.state.registration.discountEligibilityType === 'student') {
        return true;
      }
      return false;
    },
    validatingEmail() {
      return this.$store.getters.isValidatingEmail;
    },
    enableSms() {
      return this.$store.state.enableSms;
    },
    isFilled() {
      return (
        !this.validatingEmail
        && this.form.firstName !== ''
        && this.form.lastName !== ''
        && this.form.email !== ''
        && (this.enableSms || this.form.phone !== '')
        && this.form.password !== ''
        && (this.regions.length <= 1 || this.form.region !== null)
      );
    },
  },
  methods: {
    handleInvalid(e) {
      this.formErrors = {
        ...this.formErrors,
        [e.target.name]: e.target.validationMessage,
      };
    },
    handleChange(e) {
      this.formErrors = {
        ...this.formErrors,
        [e.target.name]: '',
      };
    },
    async handleSubmit() {
      if (
        this.$store.state.emailValidation.suggestion
        // eslint-disable-next-line no-alert
        && !window.confirm(`Continue with the email address ${this.form.email}?`)
      ) {
        return;
      }

      this.$store.dispatch('updateUser', this.form);
      if (!this.enableSms) {
        const isLocalNumber = this.form.phone.includes('+1');
        this.$store.dispatch('updateUser', {
          optInSms: isLocalNumber,
          allowOptInSms: isLocalNumber,
        });
      }

      this.$router.push({
        name: this.$store.getters.nextStep(this.$route.name),
      });
    },
  },
};
</script>
